import React from "react";
import "./ComparativeCard.css";
import { Paper, Typography } from "material-ui";

const ComparativeCard = props => {
  const {
    topValue,
    bottomValue,
    topTitle,
    bottomTitle,
    icon,
    iconColor
  } = props;
  const Icon = icon;
  return (
    <div className="comparative-card">
      <Paper className="top-card">
        <div className="title">
          <Typography align="left" variant="subheading" color="primary">
            {topTitle}
          </Typography>
        </div>
        <div className="value">
          <Typography
            classes={{
              colorTextSecondary: "card-value"
            }}
            align="center"
            color="textSecondary"
            variant="display2"
          >
            {topValue}
          </Typography>
        </div>
      </Paper>

      <div
        style={{ backgroundColor: iconColor ? iconColor : "#1afa9d" }}
        className="icon"
      >
        {icon && <Icon style={{ color: "#f5f5f5" }} />}
      </div>
      <Paper className="bottom-card">
        <div className="value">
          <Typography
            classes={{
              colorTextSecondary: "card-value"
            }}
            color="textSecondary"
            align="center"
            variant="display2"
          >
            {bottomValue}
          </Typography>
        </div>
        <div className="title">
          <Typography align="left" variant="subheading" color="primary">
            {bottomTitle}
          </Typography>
        </div>
      </Paper>
    </div>
  );
};

export default ComparativeCard;



// WEBPACK FOOTER //
// ./src/components/ComparativeCard/ComparativeCard.js